export { default } from "./SelectInput";



/** WEBPACK FOOTER **
 ** ./src/components/SelectInput/index.js
 **/